import React from "react";
import { useInView } from "react-intersection-observer";
import { animated, useSpring } from "react-spring";

interface ScrollAnimationWrapperProps {
    children: React.ReactNode;
    animationFrom?: object;
    animationTo?: object;
    delay?: number;
    triggerOnce?: boolean;
    threshold?: number;
}

const ScrollAnimationWrapper: React.FC<ScrollAnimationWrapperProps> = ({
    children,
    animationFrom = { opacity: 0, transform: "translateY(50px)" },
    animationTo = { opacity: 1, transform: "translateY(0)" },
    delay = 200,
    triggerOnce = true,
    threshold = 0.3,
}) => {
    const { ref, inView } = useInView({
        triggerOnce,
        threshold,
    });

    const animationProps = useSpring({
        from: animationFrom,
        to: inView ? animationTo : animationFrom,
        delay,
        config: { mass: 1, tension: 120, friction: 26 },
    });

    return (
        <animated.div ref={ref} style={animationProps}>
            {children}
        </animated.div>
    );
};

export default ScrollAnimationWrapper;
